import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type SwitchOnOffStateSortDirection = "ASC" | "DESC";

export interface SwitchOnOffStateListParams {
  page?: number;
  size?: number;
  sort?: SwitchOnOffStateSortDirection;
  sortBy?: string;
}

export interface SwitchOnOffStateRecord {
  id: string | number;
  name?: string;
  code?: string;
  description?: string;
  active?: boolean | number | string;
  baseType?: boolean;
  usedForMapping?: boolean;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  [key: string]: unknown;
}

export interface SwitchOnOffStatePayload {
  active: boolean;
  description?: string;
  name: string;
  createDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
}

export interface SwitchOnOffStateStatusPayload {
  id: string | number;
  active: boolean;
}

export interface SwitchOnOffStatePaginatedResponse {
  switchTypes?: SwitchOnOffStateRecord[];
  switchOnOffStates?: SwitchOnOffStateRecord[];
  data?: SwitchOnOffStateRecord[];
  items?: SwitchOnOffStateRecord[];
  content?: SwitchOnOffStateRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) =>
  url.replace("{id}", String(id));

export const getSwitchOnOffStatesList = (
  params: SwitchOnOffStateListParams = {},
  language?: string,
) =>
  ApiService.get<{ response: SwitchOnOffStatePaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    },
  );

export const getSwitchOnOffStateById = (
  id: string | number,
  language?: string,
) =>
  ApiService.get<{ response: SwitchOnOffStateRecord }>(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.GET,
      id,
    ),
    getLanguageHeaders(language),
  );

export const createSwitchOnOffState = (
  payload: SwitchOnOffStatePayload,
  language?: string,
) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.ADD,
    payload,
    getLanguageHeaders(language),
  );

export const updateSwitchOnOffState = (
  id: string | number,
  payload: SwitchOnOffStatePayload & { id: string | number },
  language?: string,
) =>
  ApiService.patch(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.UPDATE,
      id,
    ),
    payload,
    getLanguageHeaders(language),
  );

export const updateSwitchOnOffStateStatus = (
  id: string | number,
  payload: SwitchOnOffStateStatusPayload,
  language?: string,
) =>
  ApiService.patch(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.UPDATE,
      id,
    ),
    payload,
    getLanguageHeaders(language),
  );

export const deleteSwitchOnOffState = (
  id: string | number,
  language?: string,
) =>
  ApiService.delete(
    replaceId(
      ServicesUrlEndpoints.ADMINISTRATION.SETUP.SWITCH_ON_OFF_STATES.DELETE,
      id,
    ),
    getLanguageHeaders(language),
  );
